module.exports = __webpack_public_path__ + "static/img/4.772b368.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productCenter/4.png
// module id = 9DEN
// module chunks = 0